import React, { useState, useEffect, useCallback } from 'react';
import { apiClient } from '../utils/apiClient';

const BASE = process.env.REACT_APP_API_BASE_URL;

export default function ClasseInvites() {
    const [invites, setInvites] = useState([]);
    const [loading, setLoading] = useState(true);
    const [busy, setBusy]       = useState(null);

    const load = useCallback(async () => {
        try {
            const res  = await apiClient(`${BASE}/classe_invites.php?action=my_invites`);
            const json = await res.json();
            if (json.success) setInvites(json.invites);
        } finally { setLoading(false); }
    }, []);

    useEffect(() => { load(); }, [load]);

    const respond = async (classeId, accept) => {
        setBusy(classeId);
        try {
            await apiClient(`${BASE}/classe_invites.php?action=respond`, {
                method: 'POST',
                body: JSON.stringify({ classe_id: classeId, accept }),
            });
            setInvites(prev => prev.filter(i => i.classe_id !== classeId));
        } finally { setBusy(null); }
    };

    if (loading || invites.length === 0) return null;

    return (
        <div className="flex flex-col gap-3">
            {invites.map(inv => (
                <div key={inv.classe_id}
                    className="bg-teal-50 dark:bg-teal-900/20 border border-teal-200 dark:border-teal-500/30 rounded-2xl px-5 py-4 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
                    <div>
                        <p className="text-sm font-semibold text-teal-800 dark:text-teal-200">
                            Invitation à rejoindre <span className="font-bold">« {inv.classe_nom} »</span>
                        </p>
                        <p className="text-xs text-teal-600 dark:text-teal-400 mt-0.5">
                            de la part de {inv.professeur_name}
                        </p>
                    </div>
                    <div className="flex gap-2 shrink-0">
                        <button
                            onClick={() => respond(inv.classe_id, false)}
                            disabled={busy === inv.classe_id}
                            className="px-3 py-1.5 rounded-lg border border-teal-300 dark:border-teal-500/40 text-teal-700 dark:text-teal-300 text-sm hover:bg-teal-100 dark:hover:bg-teal-900/40 disabled:opacity-50 transition-colors">
                            Refuser
                        </button>
                        <button
                            onClick={() => respond(inv.classe_id, true)}
                            disabled={busy === inv.classe_id}
                            className="px-3 py-1.5 rounded-lg bg-teal-600 hover:bg-teal-500 disabled:opacity-50 text-white text-sm font-medium transition-colors">
                            {busy === inv.classe_id ? '…' : 'Accepter'}
                        </button>
                    </div>
                </div>
            ))}
        </div>
    );
}
